import {
  validateSeedData,
  printValidationReport,
} from '../data/utils/validateData'
import { seedData } from '../data/seedData'
import { getAtlasVersion } from '../lib/version'

/**
 * Manual data validation - no side effects on import
 * Call this function explicitly to run validation
 */
export function printAtlasValidation() {
  console.log('\n📊 Running Atlas Data Validation...\n')
  const result = validateSeedData(seedData.accounts)
  printValidationReport(result)
  return result
}

/**
 * Console helper to check current version
 * Usage: window.atlasVersion()
 */
;(window as any).atlasVersion = () => {
  const version = getAtlasVersion()
  console.log('[Quad Atlas] Version:', version)
  console.log('[Quad Atlas] Auto-generated from build timestamp')
  return version
}
